import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import AppDetailPage from '../../features/apps/components/AppDetailPage';

const AppDetailPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppDetailPage />
    </ProtectedRoute>
  );
};

export default AppDetailPageRoute;
